module.exports = __webpack_public_path__ + "img/小雪-中雪.db749b7a.png";